import React from "react";

const SurveyQuestionModal = ({
  isOpen,
  onClose = () => {},
}) => {
  const dummyQuestions = [
    {
      id: "1",
      title: "Attentiveness",
      options: ["Excellent", "Meeting Expectations", "Need Improvement", "Poor"],
      selectedOption: "Excellent",
      comment: "The student was attentive and engaged in the lesson."
    },
    {
      id: "2", 
      title: "Follow instructions",
      options: ["Excellent", "Meeting Expectations", "Need Improvement", "Poor"],
      selectedOption: "Meeting Expectations",
      comment: "The student followed the instructions well and completed the task."
    },
    {
      id: "3",
      title: "Positive contribution to class",
      options: ["Excellent", "Meeting Expectations", "Need Improvement", "Poor"],
      selectedOption: "Excellent"
    },
    {
      id: "4",
      title: "Organized work",
      options: ["Excellent", "Meeting Expectations", "Need Improvement", "Poor"],
      selectedOption: "Need Improvement",
      comment: "The student's work was disorganized and lacked structure."
    },
    {
      id: "5",
      title: "Works carefully and neat",
      options: ["Excellent", "Meeting Expectations", "Need Improvement", "Poor"],
      selectedOption: "Meeting Expectations",
      comment: "The student's work was neat and organized."
    },
    {
      id: "6",
      title: "Complete tasks",
      options: ["Excellent", "Meeting Expectations", "Need Improvement", "Poor"],
      selectedOption: "Poor",
      comment: "The student did not complete the task to the best of their ability."
    },
    {
      id: "7",
      title: "Work willingly and without frustration",
      options: ["Excellent", "Meeting Expectations", "Need Improvement", "Poor"],
      selectedOption: "Excellent",
      comment: "The student was willing to work and did not show any signs of frustration."
    }
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-3/4 max-h-[80vh] overflow-y-auto rounded-lg shadow-lg p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold">
            Teacher Observation Form
          </h2>
        </div>

        <div className="space-y-6">
          {dummyQuestions.map((questionObj, qIndex) => (
            <div key={qIndex} className="relative border border-gray-200 p-4 rounded">
              <div className="flex justify-between items-start mb-2">
                <label className="block font-medium">
                  {questionObj.title}
                </label>
              </div>
              
              <div className="flex flex-col gap-4 mt-3">
                <div className="flex flex-row gap-4">
                  {questionObj.options.map((option, oIndex) => (
                    <div 
                      key={oIndex} 
                      className={`border border-gray-200 p-2 rounded cursor-pointer ${option === questionObj.selectedOption ? 'bg-[#241763] text-white' : 'hover:bg-gray-100'}`}
                    >
                      {option}
                    </div>
                  ))}
                </div>
                {questionObj.comment && (
                  <div className="text-gray-600 text-sm italic pl-2">
                    <span className="font-bold text-[#241763]">Comment:</span> {questionObj.comment}
                  </div>
                )}
              </div>
            </div>
          ))}
  
          <div className="flex justify-end space-x-4 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-400 text-white px-6 py-2 rounded hover:bg-gray-500"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyQuestionModal;
